import React from "react";
import {
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@material-ui/core";

const SelectConfig = ({
  values = [],
  value,
  onChange,
  label,
  info,
  auto,
  kv,
  plusone,
  error,
  helperText,
  disabled = false,
}) => {
  return (
    <FormControl fullWidth variant="outlined" error={error} disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={value !== undefined && value !== null ? value : ""}
        onChange={onChange}
        disabled={disabled}
      >
        {!!info && <MenuItem value="">{info}</MenuItem>}

        {auto &&
          values.map((v, i) => (
            <MenuItem key={v} value={i}>
              {v}
            </MenuItem>
          ))}

        {!auto &&
          !kv &&
          !plusone &&
          values.map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}

        {kv &&
          values.map((e) => (
            <MenuItem key={e?.key} value={e?.key}>
              {e?.value}
            </MenuItem>
          ))}

        {plusone &&
          values.map((v, i) => (
            <MenuItem key={i} value={i + 1}>
              {v}
            </MenuItem>
          ))}
      </Select>

      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default SelectConfig;